<template>
    <div v-if="tournament">
        <header class="header">
            <div class="container">
                <div class="row align-items--center">
                    <div class="col-2">
                        <a @click.prevent="handleBack('/')" class="btn btn--icon btn--white"><i class="material-icons">keyboard_arrow_left</i></a>
                    </div>

                    <div class="col-8">
                        <h1 class="header__title">Tournaments</h1>
                    </div>
                </div>
            </div>
        </header>

        <div class="container pl--0 pr--0 mb--md" v-if="tournament && tournament.status == 'new'">
            <div class="tournament-box tournament-box--lg text--center bdrs--0" :style="'background-image: url(' + tournament.image + ');'">
                <img class="tournament-box__bg" :src="tournament.image" alt="" />

                <div class="tournament-box__content">
                    <h2 class="tournament-box__title">{{ tournament.name }}</h2>

                    <ul class="list--with-icon list--inline justify-content--center mb--sm">
                        <li><svg class="icon"><use xlink:href="/img/icon-sprite.svg#calendar"></use></svg> {{ tournament.start_date }} (CET)</li>
                        <li><svg class="icon"><use xlink:href="/img/icon-sprite.svg#user"></use></svg> {{ tournament.registered_users_number }} / {{ tournament.number_of_participants }}</li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="container mb--md">
            <button @click="register" class="btn btn--block btn--primary" v-if="! tournament.registered">
                Register
                <span v-if="tournament.entry_fee">
                    (<img src="/img/icons/coin.png" alt="" style="height: .75rem; width: .75rem;"> <span>{{ tournament.entry_fee }}</span>)
                </span>
            </button>

            <button @click="goToGame" class="btn btn--block btn--primary" v-if="tournament.registered">
                Enter tournament
            </button>
        </div>

        <div class="container pl--0 pr--0">
            <div class="panel bg--layer-light bdrs--0 mb--md">
                <h2 class="title-primary mb--10"><span class="c--gradient-primary">Rewards</span></h2>

                <div class="icon-value icon-value--inline mr--md" v-if="tournament.prize_xp">
                    <img src="/img/icons/xp.png" alt="" /> {{ tournament.prize_xp }} XP
                </div>

                <div class="icon-value icon-value--inline" v-if="tournament.prize_virtual_currency">
                    <img src="/img/icons/coin.png" alt="" /> {{ tournament.prize_virtual_currency }} Quids
                </div>
            </div>

            <div class="panel bg--layer-light bdrs--0 mb--md">
                <h2 class="title-primary mb--10"><span class="c--gradient-primary">Information</span></h2>

                <p v-html="tournament.description"></p>

                <p class="mb--20">
                    <router-link :to="'/tournament/' + tournament.id + '/rules'" class="btn btn--sm btn--white miw--130">Rules</router-link>
                </p>

                <p class="text--uppercase opacity--md mb--sm">Requirements</p>

                <ul class="weight--bold mb--20">
                    <li v-if="tournament.minimum_level">
                        Minimum Level {{ tournament.minimum_level }}
                        <i v-if="user"
                           :class="{'c--danger': user && user.level < tournament.minimum_level, 'c--success': user && user.level >= tournament.minimum_level}"
                           class="material-icons">
                            {{ user && user.level >= tournament.minimum_level ? 'check' : 'close' }}
                        </i>
                    </li>
                    <li v-if="tournament.minimum_xp">
                        Minimum {{ tournament.minimum_xp }} XP
                        <i v-if="user"
                           :class="{'c--danger': user && user.xp_points < tournament.minimum_xp, 'c--success': user && user.xp_points >= tournament.minimum_xp}"
                           class="material-icons">
                            {{ user && user.xp_points >= tournament.minimum_xp ? 'check' : 'close' }}
                        </i>
                    </li>
                    <li v-if="tournament.badges.length">
                        {{ tournament.badges.length }} badge
                        <i v-if="user"
                           :class="{'c--danger': ! hasBadges(), 'c--success': hasBadges()}"
                           class="material-icons c--success">
                            {{ hasBadges() ? 'check' : 'close' }}
                        </i>
                    </li>
                </ul>

                <p class="text--uppercase opacity--md mb--md" v-if="tournament.badges.length ">Required badges</p>

                <ul class="row">
                    <li v-for="badge in tournament.badges" class="col-3 iconbox mb--md">
                        <img :src="badge.image" :alt="badge.name" />
                        <span>{{ badge.name }}</span>
                    </li>
                </ul>
            </div>
        </div>
        <navigation></navigation>

        <modal show="false" type="error" ref="validationModal">
            <template v-slot:message>
                <div v-if="errors.any()">
                    <div v-for="error in errors.all()">{{ error }}</div>
                </div>
            </template>

            <template v-slot:title>
                Error
            </template>

            <template v-slot:buttons><span></span></template>
        </modal>

        <modal show="false" type="success" ref="successRegistrationModal">
            <template v-slot:message>
                <div>
                    You have successfully registered for this tournament.
                </div>
            </template>

            <template v-slot:title>
                Successful registration!
            </template>

            <template v-slot:buttons><span></span></template>
        </modal>
    </div>
</template>

<script>

import Errors from "../../util/Errors";
import Navigation from "../partial/Navigation";
import api from "../../api/tournaments";
import internalBackRoute from "../../mixins/internalBackRoute";
import {mapGetters, mapState} from "vuex";

export default {
name: "TournamentShow",
    components: {Navigation},
    mixins: [internalBackRoute],

    props: {
        tournamentId: {
            required: true
        }
    },

    data: function () {
        return {
            tournament: null,
            errors: new Errors(),
        }
    },

    computed: {
        ...mapState('auth', [
            'user'
        ]),
        ...mapGetters('auth', [
            'hasBadge',
        ]),
    },

    methods: {
        async loadTournament() {
            try {
                let response = await api.loadTournament(this.tournamentId)

                this.tournament = response.data.data
            } catch (e) {

            }
        },

        register() {
            api.register(this.tournamentId).then(() => {
                this.tournament.registered = true
                this.$refs.successRegistrationModal.open()
            }).catch((error) => {
                if (error.response.status === 422) {
                    this.errors.record(error.response.data.errors)
                    this.$refs.validationModal.open()
                }
            })
        },

        hasBadges() {
            if (! this.user) {
                return false
            }

            return ! collect(this.tournament.badges)
                .map((badge) => this.hasBadge(badge))
                .contains(false)
        },

        goToGame() {
            this.$router.push('/game/tournament/' + this.tournament.id)
        }
    },

    created() {
        this.loadTournament()
    }
}
</script>
